import React, { useMemo } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { useChartAmountRange } from '../../../hooks/useChartData';
import ChartCard from '../wrappers/ChartCard';
import nivoCustomTheme from '../theme/nivoCustomTheme';
import useResponsive from '../../../hooks/useResponsive';

const BUCKET_ORDER = ['Hormiga', 'Medio', 'Grande'];
const BUCKET_COLORS = { Hormiga: '#5B8BC6', Medio: '#26619C', Grande: '#1A4A7A' };
const formatCLP = (v) => `$${Math.round(v).toLocaleString('es-CL')}`;

export default function AmountRangeBarChart({ dateFrom, dateTo, categoryIds }) {
  const { isMobile } = useResponsive();
  const { data, loading, error } = useChartAmountRange({ dateFrom, dateTo, categoryIds });

  const chartData = useMemo(() => {
    if (!data?.chartAmountRange) return [];
    return [...data.chartAmountRange]
      .sort((a, b) => BUCKET_ORDER.indexOf(a.bucket) - BUCKET_ORDER.indexOf(b.bucket));
  }, [data]);

  return (
    <ChartCard
      title="Distribución por Rango de Monto"
      subtitle="Hormiga <$5k · Medio $5k–$50k · Grande >$50k"
      loading={loading && !data}
      error={error}
      height={280}
    >
      <ResponsiveBar
        data={chartData}
        keys={['total']}
        indexBy="bucket"
        colors={(bar) => BUCKET_COLORS[bar.indexValue] ?? '#26619C'}
        theme={nivoCustomTheme}
        margin={isMobile
          ? { top: 10, right: 10, bottom: 50, left: 50 }
          : { top: 10, right: 20, bottom: 50, left: 80 }
        }
        padding={0.35}
        axisBottom={{
          tickSize: 0,
          tickPadding: 8,
        }}
        axisLeft={{
          tickSize: 0,
          tickPadding: 8,
          format: (v) => `$${(v / 1000).toFixed(0)}k`,
        }}
        enableGridY={true}
        enableGridX={false}
        enableLabel={false}
        tooltip={({ indexValue, value, data: d }) => (
          <div style={{ background: '#fff', padding: '8px 12px', borderRadius: 8, border: '1px solid #F0F0F0', boxShadow: '0 4px 20px rgba(38,97,156,0.12)', fontSize: 12, fontFamily: '"Inter", sans-serif' }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>{indexValue}</div>
            <div>Total: {formatCLP(value)}</div>
            <div style={{ color: '#6B7280' }}>{d.count} transacciones</div>
          </div>
        )}
        animate={true}
        motionConfig="gentle"
      />
    </ChartCard>
  );
}
